import type { CargaLegendProps } from "./types-carga-legend";
import { useCargaLegend } from "./use-carga-legend";
import { CargaLegendView } from "./view-carga-legend";

export function CargaLegend(props: CargaLegendProps) {
  const vm = useCargaLegend(props);

  return <CargaLegendView {...vm} />;
}

export type * from "./types-carga-legend";
